import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const handleWhatsAppClick = () => {
    // Rastreamento Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Contact', {
        content_name: 'WhatsApp Hero',
        content_category: 'Button Click'
      });
    }
    
    window.open('https://wa.me/5585987894357?text=Olá! Gostaria de solicitar um orçamento para estamparia digital.', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/5d7e5581bdb1497e1b9661cd362300f6/2c3217cd413f9fd9b868cbf7c700afbd.jpeg')`
        }}
      ></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 text-center text-white py-20 md:py-24">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-5 md:mb-6 leading-tight px-2">
            GMX Fortaleza
            <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-normal mt-3 md:mt-4 text-purple-300">
              Estamparia Digital de Alta Performance
            </span>
          </h2>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-7 md:mb-8 text-gray-100 max-w-3xl mx-auto px-4 leading-relaxed">
            Aqui o ritmo é outro. Estampas com qualidade, cores que duram, entrega ágil.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 mb-8 sm:mb-10 md:mb-12 px-4 max-w-3xl mx-auto">
            <div className="bg-white/20 backdrop-blur-sm rounded-xl px-5 sm:px-6 md:px-8 py-3 md:py-4 w-full sm:w-auto">
              <span className="text-xl sm:text-2xl md:text-3xl font-bold text-yellow-300">+100.000</span>
              <span className="text-sm sm:text-base md:text-lg ml-2">pedidos entregues</span>
            </div>
            
            <div className="bg-white/20 backdrop-blur-sm rounded-xl px-5 sm:px-6 md:px-8 py-3 md:py-4 w-full sm:w-auto">
              <span className="text-xl sm:text-2xl md:text-3xl font-bold text-green-300">24h</span>
              <span className="text-sm sm:text-base md:text-lg ml-2">entrega expressa</span>
            </div>
          </div>
          
          <div className="px-4 max-w-2xl mx-auto">
            <Button 
              onClick={handleWhatsAppClick}
              size="lg"
              icon="ri-whatsapp-fill"
              className="text-sm sm:text-base md:text-lg px-6 sm:px-8 md:px-12 py-4 sm:py-5 md:py-6 w-full sm:w-auto shadow-2xl hover:scale-105 transform transition-transform"
            >
              Solicitar Orçamento
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
};
